import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import React, { useEffect, useRef, useState } from "react";
import { useTranslate } from "react-polyglot";
import { useChat } from "../../../../Providers/Data/ChatProvider.jsx";
import { useDialogs } from "../../../../Providers/Common/DialogsProvider.jsx";

const useStyles = makeStyles(
  (theme) => ({
    root: {
      borderTop: `2px solid ${theme.palette.borderColor.main}`,
      backgroundColor: "#F0EFEF",
      minHeight: 90,
      overflow: "hidden",
      display: "flex",
      padding: 10,
      justifyContent: "space-between",
      alignItems: "flex-start",
    },
    textField: {
      flex: 1,
      marginRight: 10,
      "& > .MuiInputBase-root": {
        backgroundColor: "#FAFBFA",
        borderRadius: 8,
        padding: 10,
      },
      "& fieldset": {
        borderWidth: 2,
        borderRadius: 8,
        borderColor: theme.palette.borderColor.main,
      },
    },
    sendButton: {
      borderRadius: 10,
    },
    ellipsis: {
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      textAlign: "start",
    },
  }),
  {
    name: "MessagingBoxFooter",
  },
);

/** */
const MessagingBoxFooter = () => {
  const classes = useStyles();
  const t = useTranslate();
  const { warn } = useDialogs();
  const {
    sendMessage,
    lastWsIncomingMessage,
    lastPostedMessage,
    conversations,
    selectedEmployee,
    getConversations,
  } = useChat();
  const [typedText, setTypedText] = useState("");
  const [isTextFieldDisabled, setTextFieldDisabled] = useState(false);
  const textFieldRef = useRef(null);

  // Отслеживание успешности/неудачности отправки сообщений
  useEffect(() => {
    if (
      lastWsIncomingMessage &&
      lastWsIncomingMessage.type === "responseOnRequest" &&
      lastWsIncomingMessage.requestId === lastPostedMessage.current.requestId
    ) {
      if (lastWsIncomingMessage.success) {
        setTypedText("");

        // === если в списке диалогов ещё нет диалога с текущим собеседником, подгружаем список ===
        const hasConversation = conversations.some((c) => c.userId === selectedEmployee);
        if (!hasConversation) {
          getConversations();
        }
        // ========================================================================================
      }

      setTextFieldDisabled(false);

      // Установка фокуса на поле ввода
      // нужно подождать пока поле ввода станет доступным
      setTimeout(() => {
        textFieldRef.current?.focus();
      }, 100);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastWsIncomingMessage]);

  /** */
  const sendTypedText = () => {
    if (!typedText) return;

    setTextFieldDisabled(true);
    const requestId = Date.now().toString();
    const sanitizedText = typedText.simpleSanitize();

    if (!sanitizedText) {
      setTextFieldDisabled(false);

      if (typedText) {
        warn(t("chat.errors.wrongFormatting"));
      }

      return;
    }

    sendMessage(sanitizedText, requestId);
  };

  /** */
  const onTextFieldKeyDown = (event) => {
    const isSubmitCombo = event.key === "Enter" && (event.ctrlKey || event.metaKey);

    if (isSubmitCombo) {
      event.preventDefault(); // не вставляем перевод строки
      sendTypedText();
    }
  };

  return (
    <Box className={classes.root}>
      <TextField
        inputRef={textFieldRef}
        className={classes.textField}
        variant="outlined"
        multiline
        rowsMax={6}
        helperText={t("chat.sendHelper")}
        value={typedText}
        onChange={(e) => setTypedText(e.target.value)}
        onKeyDown={onTextFieldKeyDown}
        disabled={isTextFieldDisabled}
      />
      <Button
        className={classes.sendButton}
        classes={{ label: classes.ellipsis }}
        variant="outlined"
        onClick={() => sendTypedText()}
      >
        {t("chat.send")}
      </Button>
    </Box>
  );
};

export default MessagingBoxFooter;
